import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import Baca from './pages/Baca.vue';
import Sholat from './pages/Sholat.vue';
import Riwayat from './pages/Riwayat.vue';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/baca/:nomor/:nama/:arti',
      name: 'Baca',
      component: Baca,
    },
    {
      path: '/sholat',
      name: 'Sholat',
      component: Sholat,
    },
    {
      path: '/riwayat',
      name: 'riwayat',
      component: Riwayat,
    }
  ]
})
